var React = require('react');

function ProvidesRichFrontEnd (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Provides-rich-front-end"),React.createElement("path",{"fill":"#12ebae","d":"M0 1.488v29.023c0 0.822 0.666 1.488 1.488 1.488v0h29.023c0.822 0 1.488-0.666 1.488-1.488v0-29.023c0-0.822-0.666-1.488-1.488-1.488v0h-29.023c-0.822 0-1.488 0.666-1.488 1.488v0zM29.767 29.767h-27.535v-27.535h27.535zM13.023 17.712l-3.423-1.712 3.423-1.712v-2.53l-6.474 3.2v2.009l6.474 3.2zM25.451 15.033l-6.474-3.2v2.53l3.423 1.712-3.423 1.712v2.53l6.474-3.2zM18.902 10.344l-2.158-0.67-3.721 11.981 2.158 0.67z","key":1})]);
}

ProvidesRichFrontEnd.defaultProps = {"version":"1.1","width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = ProvidesRichFrontEnd;

ProvidesRichFrontEnd.default = ProvidesRichFrontEnd;
